
export default {
  props: {
    result: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      url: ''
    }
  },
  watch: {
    url(newval, oldval) {
      this.$emit('setemaifn', newval)
    }
  }
}
